import type { Maybe } from '@/shared/libs';
import sdk from '@psp-aggregator/sdk';

export const useProviderAvailabilityImpact = (
  providerId: Maybe<string>,
  enabled = true,
) =>
  sdk.queries.useGetProviderAvailabilityImpact(providerId ?? '', {
    enabled: Boolean(providerId) && enabled,
  });
